import { crossOriginRequestJson } from '../lib/flexeApi';
import { PatPricingResponse } from './data/PricingV2Interfaces';

export class PricingV2Service {
  public async retrievePatPricing(scopeId: number): Promise<PatPricingResponse> {
    const patResponse = await crossOriginRequestJson('GET', `/api/v2/admin/pricing/pat/${scopeId}`);

    if (patResponse.status !== 200) {
      throw new Error(`Could not load PAT pricing; request returned status ${patResponse.status}`);
    }

    const parsedPatResponse = await patResponse.json();

    return parsedPatResponse.data as PatPricingResponse;
  }
}
